export const STATUS_DEFAULT = 'default';
export const STATUS_LOADING = 'loading';
export const STATUS_FAILURE = 'failure';
export const STATUS_UNKNOWN = 'unknown';
export const STATUS_SUCCESS = 'success';
